import * as bricksAndFigs from './01-bricks-and-figs.jsx';
import * as freshCutPaper from './02-fresh-cut-paper.jsx';
import * as mivi from './03-mivi.jsx';
import * as mysecretcase from './04-mysecretcase.jsx';
import * as picmondoo from './05-picmondoo.jsx';

const cases = [bricksAndFigs, freshCutPaper, mivi, mysecretcase, picmondoo];

export const CASE_STUDIES = cases.map((c) => ({ ...c.meta, Content: c.default }));

export const getCaseStudyBySlug = (slug) => CASE_STUDIES.find((c) => c.slug === slug);

export const getAdjacent = (slug) => {
  const i = CASE_STUDIES.findIndex((c) => c.slug === slug);
  if (i < 0) return { prev: null, next: null };
  return {
    prev: i > 0 ? CASE_STUDIES[i - 1] : null,
    next: i < CASE_STUDIES.length - 1 ? CASE_STUDIES[i + 1] : null
  };
};

// Other case studies (excludes the current one) for the "More stories" grid.
export const getOthers = (slug, limit = 3) =>
  CASE_STUDIES.filter((c) => c.slug !== slug).slice(0, limit);
